export default {"src":"/_next/static/media/logo-white.dce1d21f.svg","height":42,"width":132,"blurWidth":0,"blurHeight":0};